export default "__VITE_ASSET__DYVGQUlq__"